export default __webpack_public_path__ + "static/media/shake.c7165a1f.svg";